import React from 'react';
import { useUser } from '~/providers/user';
import NewDocumentView from './new_document_view';
import OldDocumentView from './old_document_view';
const DocumentView = () => {
    const { useNewView } = useUser();
    return useNewView ? React.createElement(NewDocumentView, null) : React.createElement(OldDocumentView, null);
};
export default DocumentView;
